// ViewingRequests.styles.js
const ViewingRequestsStyles = {
    scheduledViewingsSection: {
      marginTop: '3rem',
      padding: '1rem',
    },
    sectionTitle: {
      fontSize: '1.5rem',
      fontWeight: 'bold',
      color: '#81c241', // Vibrant blue for emphasis
      marginBottom: '1rem',
    },
    viewingContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '1.5rem',
    },
    viewingCard: {
      width: '320px',
      borderRadius: '12px',
      overflow: 'hidden',
      boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
      transition: 'transform 0.2s ease, box-shadow 0.2s ease',
      '&:hover': {
        transform: 'translateY(-4px)',
        boxShadow: '0 8px 20px rgba(0,0,0,0.15)',
      },
      backgroundColor: '#fff',
    },
    cardMedia: {
      height: 180,
      objectFit: 'cover',
    },
    cardContent: {
      padding: '1.5rem',
    },
    dateText: {
      fontSize: '1.25rem',
      fontWeight: '600',
      color: '#81c241',
      marginBottom: '0.75rem',
    },
    statusContainer: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '1rem',
      padding: '0.5rem',
      borderRadius: '6px',
      backgroundColor: '#f9f9f9',
    },
    statusIcon: {
      marginRight: '0.5rem',
    },
    statusText: {
      fontWeight: '500',
      textTransform: 'uppercase',
    },
    divider: {
      margin: '1rem 0',
      backgroundColor: '#f9f9f9',
    },
    infoText: {
      color: '#666',
      marginBottom: '0.5rem',
      fontSize: '0.95rem',
    },
    buttonContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: '0.5rem',
      marginTop: '1rem',
    },
    approveAndGenerateButton: {
      backgroundColor: '#81c241', // Blue
      color: '#fff',
      flex: 1,
      padding: '0.5rem',
      fontWeight: '500',
      '&:hover': {
        backgroundColor: '#6aa832',
      },
    },
    denyButton: {
      backgroundColor: '#333333',
      color: '#fff',
      flex: 1,
      padding: '0.5rem',
      fontWeight: '500',
      '&:hover': {
        backgroundColor: '#000000',
      },
    },
    message: {
      margin: '2rem 0',
      fontSize: '1.2rem',
      color: '#666',
      textAlign: 'center',
    },
  };
  
  export default ViewingRequestsStyles;